
/* @ngInject */
const ask = (utils) => {
  const self = {}

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/services/ask.service.js